import Iconify from 'src/components/Iconify';
import {
  EndUsersRoutes,
  AdminUsersRoutes,
  TransactionsRoutes,
  HomePagesRoutes,
  SpecificationAdminRoutes,
  FiscalItemClaimsRoutes,
} from '../Routes';
import { ICONS } from './navIcons';

export const insuranceAdminNavConfig = [
  {
    subheader: 'general',
    items: [{ title: 'Home', path: HomePagesRoutes.platformAdminHomePage, icon: ICONS.dashboard }],
  },
  {
    subheader: 'Korisnici',
    items: [
      {
        title: 'Osiguranici',
        path: EndUsersRoutes.index,
        icon: ICONS.user,
      },
      {
        title: 'Administratori',
        path: AdminUsersRoutes.index,
        icon: ICONS.lock,
      },
    ],
  },
  {
    subheader: 'Transakcije',
    items: [
      {
        title: 'Transakcije',
        path: TransactionsRoutes.index,
        icon: ICONS.invoice,
      },
      {
        title: 'Specifikacije',
        path: SpecificationAdminRoutes.index,
        icon: ICONS.banking,
      },
    ],
  },
  {
    subheader: 'E-Fiscal',
    items: [
      {
        title: 'Reklamacije',
        path: FiscalItemClaimsRoutes.index,
        icon: <Iconify icon={'mdi:contract-sign'} />,
      },
    ],
  },
];
